import api from './api';

export const createRSVP = async (rsvpData) => {
  // Split name into firstName/lastName as required by backend
  const nameParts = (rsvpData.name || '').trim().split(' ');
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || firstName;

  const payload = {
    ...rsvpData,
    firstName,
    lastName,
    packageType: 'nine-and-dine',
    packagePrice: rsvpData.registrationType === 'contractor' ? 300 : 0,
  };

  const response = await api.post('/rsvps', payload);
  return response.data;
};

export const createCheckoutSession = async (rsvpData) => {
  const response = await api.post('/rsvps/create-checkout-session', rsvpData);
  return response.data;
};
